import { NgModule } from "@angular/core";
import { ProfileComponent } from "./profile.component";
import { CoreModule } from "../../../core/core.module";
import { TermsAndConditionsUpdatesModule } from "@modules/shared/terms-and-conditions/components/terms-and-conditions-updates.module";
import { BpGoogleAutocompleteModule } from "@modules/shared/bp-google-autocomplete/bp-google-autocomplete.module";

const components = [ProfileComponent];

@NgModule({
	imports: [CoreModule, TermsAndConditionsUpdatesModule, BpGoogleAutocompleteModule],
	declarations: [...components],
	exports: [...components]
})
export class ProfileModule {}
